import { createAsyncThunk } from "@reduxjs/toolkit";

import { getMembershipDetails } from "../../../api/memberships";
import { getApiErrorMessage } from "../../../utils/apiErrorMessage";

export const loadMembershipData = createAsyncThunk(
  "membership/fetch",
  async (membershipId, { rejectWithValue }) => {
    try {
      return await getMembershipDetails(membershipId);
    } catch (error: unknown) {
      console.error("load membership data error: ", error);
      // Siempre un string en el store: `data.message` puede ser el
      // diccionario de errores del serializer.
      return rejectWithValue(
        getApiErrorMessage(error, "No pudimos cargar tu membresía."),
      );
    }
  },
);
